// Mock data for dashboard

export const mockStore = {
  currentBusiness: {
    name: 'Starlight Cafe',
    id: 'starlight-cafe-001'
  },
  user: {
    name: 'Alex Grim',
    businessName: 'Starlight Cafe',
    avatar: 'https://i.pravatar.cc/150?img=12'
  }
};

export const mockQuery = {
  dashboardMetrics: {
    totalReviews: {
      value: 1204,
      change: 5.2
    },
    averageRating: {
      value: 4.8,
      maxRating: 5,
      change: 0.1
    },
    sentimentScore: {
      value: 92,
      change: 1.5
    },
    googleBusinessRating: {
      value: 4.8,
      change: 5.5
    },
    googleBusinessReviews: {
      value: 20124,
      change: 3.0
    },
    riteReviewPlatformReviews: {
      value: 34123,
      change: -2.0
    },
    totalCampaigns: {
      value: 43234,
      change: 5.0
    },
    totalParticipants: {
      value: 18989,
      change: 55.0
    },
    totalRewardsClaimed: {
      value: 1523,
      change: 8.2
    },
    cashAmountClaimed: {
      value: 45230,
      change: 12.5
    },
    couponsClaimed: {
      value: 892,
      change: 6.8
    }
  },
  reviewTrends: [
    { week: 'Week 1', count: 270 },
    { week: 'Week 2', count: 240 },
    { week: 'Week 3', count: 180 },
    { week: 'Week 4', count: 210 }
  ],
  reviewsByMonth: [
    { month: 'Jan', count: 23400 },
    { month: 'Feb', count: 15000 },
    { month: 'Mar', count: 30000 },
    { month: 'Apr', count: 22000 },
    { month: 'May', count: 10000 },
    { month: 'Jun', count: 23400 },
    { month: 'Jul', count: 5000 }
  ],
  sentimentAnalysis: {
    positive: 32889,
    neutral: 11345,
    negative: 12399
  },
  rewardRequests: [
    {
      id: 'req-001',
      userName: 'Jane Doe',
      rewardType: 'Free Coffee',
      avatar: 'https://i.pravatar.cc/150?img=1',
      status: 'pending' as const
    },
    {
      id: 'req-002',
      userName: 'John Smith',
      rewardType: '10% Discount',
      avatar: 'https://i.pravatar.cc/150?img=3',
      status: 'pending' as const
    },
    {
      id: 'req-003',
      userName: 'Sarah Miller',
      rewardType: 'Free Pastry',
      avatar: 'https://i.pravatar.cc/150?img=5',
      status: 'pending' as const
    }
  ]
};

export const mockRootProps = {
  timeRange: 'Last 30 Days' as const
};